import type { SVGProps } from 'react';
const SvgWbIncandescent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#wb_incandescent_svg__a)">
      <path
        fill="currentColor"
        d="m3.55 18.54 1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8ZM11 22.45h2V19.5h-2v2.95ZM4 10.5H1v2h3v-2Zm11-4.19V1.5H9v4.81C7.21 7.35 6 9.28 6 11.5c0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.22-1.21-4.15-3-5.19Zm5 4.19v2h3v-2h-3Zm-2.76 7.66 1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4Z"
      />
    </g>
    <defs>
      <clipPath id="wb_incandescent_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWbIncandescent;
